<div id="addStoreProductModal" rvSpinner="product-list-loader" [rvShowSpinner]="products.loadingItems">
  <div class="modal-header">
    <button type="button" class="close" (click)="close()" aria-label="Close this modal">
      <streamline-icon name="close" width="12" height="12"></streamline-icon>
    </button>
    <h2 id="storeModalTitle" class="modal-title text-center tw-text-[16px] tw-font-semibold">Add Presentation</h2>
  </div>
  <div class="modal-body u_padding-lg">
    <div class="row">
      <div id="template-filters">
        <div class="border-round">
          <div class="p-3 border-bottom">
            <h3 class="tw-text-[14px] tw-font-bold tw-m-0">Filters</h3>
          </div>
          <mat-accordion displayMode="flat" multi="true">
            <mat-expansion-panel class="border-bottom expansion-panel-flush mat-elevation-z0" [disabled]="!datesAvailable" [expanded]="datesAvailable">
              <mat-expansion-panel-header 
                class="p-3 show-focus" 
                role="button" 
                aria-level="3"
                tabindex="0"
                [attr.aria-expanded]="datesAvailable"
                [attr.aria-disabled]="!datesAvailable"
                aria-controls="events-calendar-panel"
                id="events-calendar-button">
                Events Calendar
              </mat-expansion-panel-header>
              <div id="events-calendar-panel" 
                   role="region" 
                   aria-labelledby="events-calendar-button">
                <template-calendar [displayed]="datesAvailable" [(selectedDate)]="selectedDate" (selectedDateChange)="doSearch()"></template-calendar>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="border-bottom mat-elevation-z0" [disabled]="!categoryFilters.templateCategories" [expanded]="preloadFilter">
              <mat-expansion-panel-header 
                class="p-3 show-focus"
                role="button" 
                aria-level="3"
                tabindex="0"
                [attr.aria-expanded]="preloadFilter"
                [attr.aria-disabled]="!categoryFilters.templateCategories"
                aria-controls="category-panel"
                id="category-button">
                Category
              </mat-expansion-panel-header>
              <div id="category-panel" 
                   role="region" 
                   aria-labelledby="category-button">
                @for (category of categoryFilters.templateCategories; track category) {
                  <div>
                    <mat-checkbox #FilterCheckbox id="checkbox-templateCategories-{{ slugify(category.name) }}" (change)="setFilter($event, 'templateCategories', category.name)" [disabled]="showSharedTemplates">
                      {{ category.name }} ({{ category.count }})
                    </mat-checkbox>
                  </div>
                }
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="border-bottom u_remove-radius mat-elevation-z0" [disabled]="!categoryFilters.templateContentTypes">
              <mat-expansion-panel-header 
                class="p-3 show-focus"
                role="button" 
                aria-level="3"
                tabindex="0"
                [attr.aria-expanded]="!!categoryFilters.templateContentTypes"
                [attr.aria-disabled]="!categoryFilters.templateContentTypes"
                aria-controls="content-panel"
                id="content-button">
                Content
              </mat-expansion-panel-header>
              <div id="content-panel" 
                   role="region" 
                   aria-labelledby="content-button">
                @for (contentType of categoryFilters.templateContentTypes; track contentType) {
                  <div>
                    <mat-checkbox #FilterCheckbox id="checkbox-templateContentTypes-{{ slugify(contentType.name) }}" (change)="setFilter($event, 'templateContentTypes', contentType.name)" [disabled]="showSharedTemplates">
                      {{ contentType.name }} ({{ contentType.count }})
                    </mat-checkbox>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <div class="flex-row left-right-aligner p-3" [ngClass]="{ 'border-bottom': templates.items.list.length }">
            <label for="apple-tv-toggle" id="apple-tv-label" class="font-weight-normal mb-0 u_clickable">Apple TV Compatible</label>
            <mat-slide-toggle id="apple-tv-toggle" class="pl-3" [checked]="filterAppleTv" (change)="toggleAppleTv()" [disabled]="showSharedTemplates" ariaLabelledby="apple-tv-label"></mat-slide-toggle>
          </div>
          <div class="flex-row left-right-aligner p-3" [shown]="templates.items.list.length">
            <label for="templates-source-toggle-button" id="shared-templates-label" class="font-weight-normal mb-0 u_clickable">Shared Templates</label>
            <mat-slide-toggle id="templates-source-toggle" class="pl-3" [checked]="showSharedTemplates" (change)="toggleTemplatesSource()" ariaLabelledby="shared-templates-label"></mat-slide-toggle>
          </div>
        </div>
      </div>
      <div id="template-grid">
        <div class="u_margin-sm-bottom">
          <search-filter [filterConfig]="filterConfig" [search]="search" [doSearch]="search.doSearch" [localSearch]="showSharedTemplates" [focus]="focusSearch"></search-filter>
        </div>
        <section id="productList" class="product-grid" scrollingList>
          <div #TemplatesGrid class="professional-content panel panel-default border-container mb-0">
            <ng-template #BlankPresentation>
              <!-- Template Image -->
              <div class="template-image" uiSref="apps.editor.workspace.artboard" (click)="close()">
                <img loading="lazy" class="img-responsive" src="https://widgets.risevision.com/apps/logos/blank-landscape.png" alt="add blank presentation">
                <span class="cta">Use this Template</span>
                <span class="template-fx"></span>
              </div>
              <!-- Template Details -->
              <div class="template-details">
                <div class="template-title">
                  <span>Blank - Legacy Editor</span>
                </div>
                <div class="template-button">
                  <button mat-icon-button class="icon-button" color="primary" id="newPresentationButton" uiSref="apps.editor.workspace.artboard" (click)="close()" aria-label="Use this template">
                    <mat-icon svgIcon="add" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </ng-template>
            <ng-template #Presentation let-product>
              <!-- Template Image -->
              <div class="template-image" [ngClass]="{'shared' : !product.imageUrl}" (click)="select(product)">
                @if (product.imageUrl) {
                  <img loading="lazy" [src]="product.imageUrl" alt="{{product.imageAlt || product.name}}">
                }
                @else {
                  <streamline-icon aria-hidden="true" name="iconPresentation" width="100%" height="100%"></streamline-icon>
                }
                @if (product.imageUrl) {
                  <span class="cta">{{ isAlertTemplate(product) ? 'Configure Alerts' : 'Preview this Template' }}</span>
                }
                @else {
                  <span class="cta">Use this Template</span>
                }
                <span class="template-fx"></span>
                <div class="template-tag" [shown]="product.templateTag">{{ product.templateTag }}</div>
              </div>
              <!-- Template Details -->
              <div class="template-details">
                <div class="template-title">
                  <div class="flex-row">
                    <span id="productName-{{slugify(product.name)}}">{{product.name | slice: 0: 65}}</span>
                    @if (requiresUpgrade(product)) {
                      <upgrade-notice (closeEvent)="close()" feature="power_bi" class="ml-2 mt-2"></upgrade-notice>
                    }
                  </div>
                </div>
                <div class="template-button" [ngClass]="{ 'alert-button': isAlertTemplate(product) }">
                  <button mat-flat-button class="icon-button" color="primary" id="btn-{{slugify(product.name)}}" (click)="add(product)" aria-label="Use this template">
                    <mat-icon [svgIcon]="isAlertTemplate(product) ? 'settings' : 'add'" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </ng-template>
            @if (!showSharedTemplates) {
              @if (!filteredResults && newTemplates.length) {
                <div>
                  @if (templatesService.upcomingEvents.length) {
                    <div>
                      <h3 class="product-grid-header">Upcoming Events</h3>
                      <ul class="panel-body template-list">
                        @for (template of templatesService.upcomingEvents; track template) {
                          <li id="storeProduct-{{ slugify(template.name) }}" class="template-card gallery-card">
                            <ng-container *ngTemplateOutlet="Presentation; context: { $implicit: template }"></ng-container>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                  
                  <div class="ai-chatbot-generate-presentations-banner" *requireRole="'!PROD'">
                    <img class="ai-chatbot-generate-presentations-banner-background" src="/images/ai-chatbot/ai-chatbot-generate-presentations-banner-background.png" title="Generate presentations background"/>
                    <div class="ai-chatbot-generate-presentations-banner-info">
                      <div class="ai-chatbot-generate-presentations-banner-info-header">
                        <mat-icon svgIcon="ai-chatbot-star" class="ai-chatbot-generate-presentations-banner-info-header-icon"></mat-icon>
                        <span class="ai-chatbot-generate-presentations-banner-info-header-text rise-admin-only">AI Powered</span>
                      </div>
                      
                      <div class="ai-chatbot-generate-presentations-banner-info-title">
                        <span class="ai-chatbot-generate-presentations-banner-info-title-text"><b>Generate</b> Presentations</span>
                      </div>

                      <div class="ai-chatbot-generate-presentations-banner-info-text">
                        <span>Easily create stunning templates tailored to your <b>brand, theme, and industry</b>.</span>
                        <span>Just tell our AI powered sidekick Pixel what you need—and watch it build ready-to-use designs in seconds.</span>
                      </div>
                    </div>

                    <div class="ai-chatbot-generate-presentations-banner-button-container">
                      <ai-chatbot-generate-presentations-button (openAiChatbot)="openAiChatbot()"></ai-chatbot-generate-presentations-button>
                    </div>
                  </div>

                  <h3 class="product-grid-header">Featured Templates</h3>
                  <ul class="panel-body template-list">
                    @for (template of newTemplates; track template) {
                      <li id="storeProduct-{{ slugify(template.name) }}" class="template-card gallery-card">
                        <ng-container *ngTemplateOutlet="Presentation; context: { $implicit: template }"></ng-container>
                      </li>
                    }
                  </ul>
                  <h3 class="product-grid-header">More Templates</h3>
                </div>
              }
              @if (!products.loadingItems && (filteredResults)) {
                <div>
                  @if (!showSharedTemplates) {
                    <div class="flex-row">
                      <h3 class="product-grid-header">Search Results</h3>
                      <mat-chip-set role="list">
                        @if (selectedDate) {
                          <mat-chip
                            role="listitem"
                            color="accent"
                            highlighted
                            (removed)="clearDate()">
                            {{ templatesService.formatDateName(selectedDate) }}
                            <button matChipRemove tabindex="0" aria-label="Remove selected date" 
                                    (keydown.enter)="clearDate()" 
                                    (keydown.space)="clearDate()">
                              <streamline-icon name="close" width="12" height="12"></streamline-icon>
                            </button>
                          </mat-chip>
                        }
                        @if (filterAppleTv) {
                          <mat-chip
                            role="listitem"
                            color="accent"
                            highlighted
                            (removed)="clearAppleTv()">
                            Apple TV
                            <button matChipRemove tabindex="0" aria-label="Remove Apple TV filter" 
                                    (keydown.enter)="clearAppleTv()" 
                                    (keydown.space)="clearAppleTv()">
                              <streamline-icon name="close" width="12" height="12"></streamline-icon>
                            </button>
                          </mat-chip>
                        }
                        @for (key of searchFilterKeys; track key) {
                          <span>
                            @for (filter of search.templatesFilter[key]; track filter) {
                              <mat-chip
                                role="listitem"
                                color="accent"
                                highlighted
                                tabindex="0"
                                [value]="key + ':' + filter"
                                (keydown.enter)="clearFilter(key + ':' + filter)" 
                                (keydown.space)="clearFilter(key + ':' + filter)"
                                (removed)="clearFilter($event.chip.value)">
                                {{ filter }}
                                <button matChipRemove [attr.aria-label]="'Remove ' + filter + ' filter'">
                                  <streamline-icon name="close" width="12" height="12"></streamline-icon>
                                </button>
                              </mat-chip>
                            }
                          </span>
                        }
                        @if (selectedDate || filterAppleTv || searchFilterKeys.length) {
                          <mat-chip
                            role="listitem"
                            color="accent"
                            highlighted
                            tabindex="0"
                            class="u_clickable inverted"
                            (click)="clearAllFilters()"
                            (keydown.enter)="clearAllFilters()"
                            (keydown.space)="clearAllFilters()">
                            Clear Filters
                          </mat-chip>
                        }
                      </mat-chip-set>
                    </div>
                  }
                </div>
              }
              @if (selectedDate) {
                <div>
                  @for (group of templateGroups; track group) {
                    <div>
                      <h6 class="product-grid-group-header" [ngClass]="{ 'mt-2': group === templateGroups[0] }">{{ group.name }}</h6>
                      <ul class="panel-body template-list">
                        @for (template of group.templates; track template) {
                          <li id="template-{{ slugify( template.name )}}" class="template-card gallery-card">
                            <ng-container *ngTemplateOutlet="Presentation; context: { $implicit: template }"></ng-container>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                  @if (templateGroups?.length) {
                    <h3 class="product-grid-header">More Results</h3>
                  }
                </div>
              }

              <ul class="panel-body template-list">
                <ng-container *requireRole="'!PROD'">
                  <li *ngIf="filteredResults" class="ai-chatbot-generate-presentations-button-search-result-container template-card gallery-card">
                    <ai-chatbot-generate-presentations-button [isSearchResult]="true" (openAiChatbot)="openAiChatbot(search.query)"></ai-chatbot-generate-presentations-button>
                    <div class="template-details">
                      <div class="template-title">
                        <span>Generate Presentation with AI</span>
                      </div>
                    </div>
                  </li>
                </ng-container>

                @for (template of filteredProducts; track template) {
                  <li id="storeProduct-{{ slugify(template.name) }}" class="template-card gallery-card">
                    @if (!template.isBlank) {
                      <div>
                        <ng-container *ngTemplateOutlet="Presentation; context: { $implicit: template }"></ng-container>
                      </div>
                    }
                    @if (template.isBlank) {
                      <ng-template [ngTemplateOutlet]="BlankPresentation"></ng-template>
                    }
                  </li>
                }
              <!-- If no search results -->
                <li class="col-sm-12" [shown]="filteredProducts.length === 0 && search.query && !products.loadingItems">
                  <div class="text-muted text-center u_padding-lg">Your search didn't return any results.</div>
                </li>
                @if ((isEducationCustomer || isIndustrialCustomer) && !products.loadingItems) {
                  <li id="suggestTemplate" class="col-sm-12 text-center">
                    <h3>Can’t find what you’re looking for?</h3>
                    <a href="https://docs.google.com/forms/d/1slHKxGxywkiSakMukDr4dMGLmhzhYhoU0F2BHP8FSd4/viewform" target="_blank">
                      Suggest a Template!
                    </a>
                  </li>
                }
              </ul><!--panel-body-->
            }
            @else {
              <h3 class="product-grid-header">Shared Templates</h3>

              <ul class="panel-body template-list">
                @for (sharedTemplate of filteredSharedTemplates; track sharedTemplate) {
                  <li id="storeProduct-{{ slugify(sharedTemplate.name) }}" class="template-card gallery-card">
                    <div>
                      <ng-container *ngTemplateOutlet="Presentation; context: { $implicit: sharedTemplate }"></ng-container>
                    </div>
                  </li>
                }
                <!-- If no search results -->
                <li class="col-sm-12" [shown]="filteredSharedTemplates.length === 0 && search.query && !templates.loadingItems">
                  <div class="text-muted text-center u_padding-lg">Your search didn't return any results.</div>
                </li>
                <li class="col-sm-12 text-center" [shown]="filteredSharedTemplates.length === 0 && !search.query && !templates.loadingItems">
                  <div class="text-muted text-center u_padding-lg">
                    <span [shown]="sharedTemplatesAvailable">There aren't any shared templates to select</span>
                    <span [shown]="sharedTemplatesAvailable === null">
                      <a href="#" uiSref="apps.purchase.home" (click)="close()">Subscribe now</a> to access Shared Templates
                    </span>
                    <span [shown]="sharedTemplatesAvailable !== null && !sharedTemplatesAvailable">
                      <a href="#" (click)="showUpgradePlanModal()">Upgrade Plan</a> to access Shared Templates
                    </span>
                  </div>
                </li>
              </ul><!--panel-body-->
            }

          </div><!--panel-->
        </section>
      </div>
    </div>
  </div>
</div>
